import {connect} from "react-redux";
import Edit from "./edit";
import {bindActionCreators} from "redux";
import {documentUploadUrlPublic} from "../../../../service/fileUpload/action";
import {ucdById, ucdUpdate, newBankDetailsRequest} from "../../../../service/Dealer/action";
const mapStateToProps = (state) => ({
    documentUrlDataPublic: state.fileUploadReducer.documentUrlDataPublic,
    ucdDetails:state.Dealer.ucdDetails,
    ucsUpdateResponse:state.Dealer.ucdUpdate,
    newBankDetailsResponse: state.Dealer.newBankDetailsResponse,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            documentUploadUrlPublic,
            ucdById,
            ucdUpdate,
            newBankDetailsRequest
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(Edit);
